export default __webpack_public_path__ + "static/media/eniola.dfff4b25.webp";